/**
 * @file     breadcrumbs.ts
 * @purpose  Tiny in-memory ring buffer of recent user actions + navigations.
 *           Attached to every crash report so we can see WHAT the user did in
 *           the seconds before a crash (the missing context when a prod error
 *           isn't reproducible locally). Client-only, never throws, bounded.
 */

export interface Breadcrumb {
  /** ms epoch */
  t: number;
  /** category: 'route' | 'click' | 'gate' | 'fetch' | 'state' | ... */
  cat: string;
  msg: string;
  data?: Record<string, unknown>;
}

const MAX = 25;
const ring: Breadcrumb[] = [];

export function addBreadcrumb(cat: string, msg: string, data?: Record<string, unknown>): void {
  try {
    ring.push({ t: Date.now(), cat, msg, ...(data && Object.keys(data).length ? { data } : {}) });
    if (ring.length > MAX) ring.shift();
  } catch {
    /* breadcrumbs must never throw */
  }
}

export function getBreadcrumbs(): Breadcrumb[] {
  return ring.slice();
}
